// Toggles the visibility of an element
export const toggleVisibility = (container, elementClass) => {
  const element = container.querySelector(`${elementClass}`);
  element.classList.toggle("display-none");
};

// Expands an element
export const expand = (container, elementClass, duration) => {
  const element = container.querySelector(`${elementClass}`);
  // Prepares the element for taking expanded measurments
  element.removeAttribute("style");
  element.style.overflow = "hidden";
  element.classList.add("display-flex");
  element.classList.add("element-invisible");
  element.classList.remove("display-none");
  // Sets expanded measurments to the element
  element.style.height = `${element.offsetHeight}px`;
  // Sets element for expansion
  element.classList.add("element-collapsed");
  element.classList.remove("element-invisible");
  element.style.animation = `collapse ${duration}ms reverse forwards ease-in-out`;

  // Waits for the animation to end to reset the classes and measurements
  setTimeout(() => {
    element.classList.remove("element-collapsed");
    element.removeAttribute("style");
  }, duration);
};

// Retracts an element
export const retract = (container, elementClass, duration) => {
  const element = container.querySelector(`${elementClass}`);
  // Sets element measurments for proper animation
  element.removeAttribute("style");
  element.style.overflow = "hidden";
  element.style.height = `${element.offsetHeight}px`;
  element.style.animation = `collapse ${duration}ms forwards ease-in-out`;
  // Waits until the animation ends
  setTimeout(() => {
    element.classList.add("display-none");
    element.classList.remove("display-flex");
    element.removeAttribute("style");
  }, duration);
};

// Fades an element
export const fade = (container, elementClass, duration) => {
  const element = container.querySelector(`${elementClass}`);
  element.style.opacity = 1;
  const fadeEffect = setInterval(() => {
    if (element.style.opacity > 0) {
      element.style.opacity = element.style.opacity - 0.1;
    } else {
      clearInterval(fadeEffect);
      element.style.opacity = 1;
      element.removeAttribute("style");
      element.classList.add("display-none");
      element.classList.remove("display-flex");
    }
  }, duration);
};

// Hide others
export const hideOthers = (otherClass) => {
  const menu = document.querySelectorAll(otherClass);
  menu.forEach((element) => {
    element.classList.add("display-none");
    element.classList.remove("display-flex");
  });
};
